import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from "./components/LoginScreen";
import DashBoardScreen from "./components/DashboardScreen";
import RegisterScreen from "./components/RegisterScreen";
import OtpScreen from "./components/OtpScreen";
import ProductListScreen from "./components/ProductListScreen";
import ProductDetailsScreen from "./components/ProductDetailsScreen";
import UpdateUserInfoScreen from "./components/UpdateUserInfoScreen";
import OrderListScreen from "./components/OrderListScreen";
import CartScreen from "./components/CartScreen";
import MyAccountScreen from "./components/MyAccountScreen";
import ShippingAddressScreen from "./components/ShippingAddressScreen";
import AddShippingAddressScreen from "./components/AddShippingAddressScreen";
import SubscribeListScreen from "./components/SubscribeListScreen";
import CheckoutScreen from "./components/CheckoutScreen";
import ForgotPasswordScreen from "./components/ForgotPasswordScreen";
import ChangePasswordScreen from "./components/ChangePasswordScreen";
import CommonScreen from "./components/CommonScreen";
import FaqScreen from "./components/FaqScreen";
import StoriesScreen from "./components/StoriesScreen";
import WalletScreen from "./components/WalletScreen";
import ThankyouScreen from "./components/ThankyouScreen";
import CancelSubscriptionListScreen from "./components/CancelSubscriptionListScreen";
import ContactScreen from "./components/ContactScreen";
import InquiryScreen from "./components/InquiryScreen";
import LogSubscriptionListScreen from "./components/LogSubscriptionListScreen";
import { withNavigation } from './common/routerShim';
const DashBoard = withNavigation(DashBoardScreen);
const Login = withNavigation(LoginScreen);
const Register = withNavigation(RegisterScreen);
const Otp = withNavigation(OtpScreen);
const ProductList = withNavigation(ProductListScreen);
const ProductDetails = withNavigation(ProductDetailsScreen);
const UpdateUserInfo = withNavigation(UpdateUserInfoScreen);
const OrderList = withNavigation(OrderListScreen);
const Cart = withNavigation(CartScreen);
const MyAccount = withNavigation(MyAccountScreen);
const ShippingAddress = withNavigation(ShippingAddressScreen);
const AddShippingAddress = withNavigation(AddShippingAddressScreen);
const SubscribeList = withNavigation(SubscribeListScreen);
const Checkout = withNavigation(CheckoutScreen);
const Faq = withNavigation(FaqScreen);
const Stories = withNavigation(StoriesScreen);
const Common = withNavigation(CommonScreen);
const Contact = withNavigation(ContactScreen);
const Inquiry = withNavigation(InquiryScreen);
const Wallet = withNavigation(WalletScreen);
const Thankyou = withNavigation(ThankyouScreen);
const CancelSubscriptionList = withNavigation(CancelSubscriptionListScreen);
const LogSubscriptionList = withNavigation(LogSubscriptionListScreen);
const ChangePassword = withNavigation(ChangePasswordScreen);
const ForgotPassword = withNavigation(ForgotPasswordScreen);

function App() {
  return (
    <div className="App">
      {/* <script src="https://maps.googleapis.com/maps/api/js?key=<INSERT-API-KEY-HERE>&libraries=places&callback=initMap"async></script> */}

      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/login-screen" element={<Login />} />
          <Route path="/register-screen/:paramRefercode" element={<Register />} />
          <Route path="/register-screen" element={<Register />} />
          <Route path="/otp-screen" element={<Otp />} />
          <Route path="/products-screen" element={<ProductList />} />
          <Route path="/product-details-screen/:paramId/:isWallet" element={<ProductDetails />} />
          <Route path="/update-user-info" element={<UpdateUserInfo />} />
          <Route path="/orders" element={<OrderList />} />
          <Route path="/cart-screen" element={<Cart />} />
          <Route path="/my-account" element={<MyAccount />} />
          <Route path="/shipping-address" element={<ShippingAddress />} />
          <Route path="/add-shipping-address" element={<AddShippingAddress />} />
          <Route path="/subscriptionlist-screen" element={<SubscribeList />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/common/:paramInfoId" element={<Common />} />
          <Route path="/contact-screen" element={<Contact />} />
          <Route path="/inquiry-screen" element={<Inquiry />} />
          <Route path="/wallet-screen" element={<Wallet />} />
          <Route path="/thank-you" element={<Thankyou />} />
          <Route path="/cancelled-subscriptions" element={<CancelSubscriptionList />} />
          <Route path="/subscription-logs" element={<LogSubscriptionList />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
